<template>
  <div class="offerPopup">
    <div class="popupWrapper">
      <div class="closeButton">
        <img
          src="@/assets/icons/closeIcon.svg"
          alt="closeIcon"
          @click="changePopupState(false)"
        />
      </div>
      <div class="wrapper">
        <template v-for="(contentItem, index) in contentForDesktop">
          <div
            v-if="index % 2 === 0"
            :key="index"
            class="boxTitle text18"
            :class="{ boxBottom: index === contentForDesktop.length - 2 }"
          >
            {{ contentItem }}
          </div>
          <div
            v-if="index % 2 === 1"
            :key="index"
            class="boxText boxFull text13 textSpacing5"
            :class="{ boxBottom: index === contentForDesktop.length - 1 }"
          >
            {{ contentItem }}
          </div>
        </template>
      </div>
      <div class="mobileWrapper">
        <div v-for="(contentItem, index) in content" :key="contentItem.text">
          <div
            class="optionWrapper"
            :class="{ lastOption: index === content.length - 1 }"
          >
            <div class="optionTitle">{{ contentItem.title }}</div>
            <div class="optionState">
              <span class="stateText text13">{{ contentItem.text }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    content: {
      type: Array,
      required: true
    },
    isOffer: {
      type: Boolean,
      require: true
    }
  },
  computed: {
    contentForDesktop() {
      return [].concat.apply(
        [],
        this.content.map((content) => [content.title, content.text])
      );
    }
  },
  methods: {
    changePopupState(payload) {
      // can be improved
      if (this.isOffer) this.$store.commit('changePopupState', payload);
      else this.$store.commit('changeTimetablePopupState', payload);

      document.body.classList.toggle('hiddenOverflow');
      document.querySelector('.blurred').classList.toggle('active');
    }
  }
};
</script>
<style lang="scss" scoped>
.offerPopup {
  box-sizing: border-box;
  position: fixed;
  z-index: 70;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
}
.popupWrapper {
  background: #ffffff;
  position: relative;
  color: #4f388d;
  padding: 0.83rem;
  width: 75rem;
  height: auto;
  z-index: 100;
  border-radius: 15px;
  box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.25);
}
.closeButton {
  cursor: pointer;
  position: absolute;
  z-index: 999;
  right: -1.25rem;
  top: -1.3rem;
}
.closeButton > img {
  width: 2.57rem;
  height: 2.57rem;
}
.wrapper {
  display: grid;
  grid-template-columns: 1.7fr repeat(2, 3fr);
}

.boxTitle {
  border: 2px solid rgba(79, 56, 141, 0.2);
  border-left: 0;
  border-top: 0;
  padding: 1.6rem 0.69rem;
  font-weight: 500;
  letter-spacing: 0.1rem;
}
.boxText {
  border-bottom: 2px solid rgba(79, 56, 141, 0.2);
  width: 100%;
  padding: 1.6rem 9.58rem;
  display: flex;
  align-items: center;
}

.boxFull {
  grid-column-start: 2;
  grid-column-end: 4;
}
.boxBottom {
  border-bottom: none;
}
.mobileWrapper {
  display: none;
}
@media screen and (max-width: 768px) {
  .mobileWrapper {
    display: block !important;
    width: 100%;
    padding: 3.5rem 3.125rem;
  }
  .wrapper {
    display: none;
  }

  .offerPopup {
    padding: 5rem 2.5rem;
  }
  .popupWrapper {
    position: relative;
    overflow-y: scroll;
    width: 100%;
    height: 100%;
    z-index: 100;
    border-radius: 15px;
  }
  .popupWrapper::-webkit-scrollbar {
    display: none;
  }
  .closeButton {
    cursor: pointer;
    position: fixed;
    z-index: 150;
    top: 6rem;
    right: 4.2rem;
  }
  .closeButton > img {
    width: 10rem;
    height: auto;
  }

  .optionWrapper {
    display: flex;
    flex-direction: column;
    padding-bottom: 7.5rem;
    border-bottom: 2px solid rgba(79, 56, 141, 0.2);
  }
  .lastOption {
    border-bottom: none;
  }
  .optionTitle {
    margin-top: 7.5rem;
    font-size: 6.25rem;
    line-height: 7.61rem;
    letter-spacing: 0.1rem;
    font-weight: 500;
  }
  .optionState {
    display: flex;
    flex-direction: column;
  }
  .stateText {
    letter-spacing: 0.05rem;
    margin-top: 3.75rem;
  }
}
</style>
